import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext } from 'react';
import styled from 'styled-components';
import ImageLink from '../../../../../../components/Molecules/ImageLink/ImageLink';
import { media } from '../../../../../../theme/shared/breakpoints';
import { Link } from '../../../../../components/Link/Link';
import { NaviagationContext } from '../MobileNavigationItem';
const List = styled.ul `
  list-style: none;
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-template-rows: repeat(1, 1fr);
  grid-row-gap: 15px;
  margin-bottom: 25px !important;

  ${media.xSmall} {
    grid-column-gap: 15px;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(1, 1fr);
  }
`;
const ListItem = styled.li `
  height: 54px;
`;
const HeaderContainer = styled.div `
  display: flex;
  justify-content: space-between;
  padding-bottom: 20px;
`;
const ColumnTitle = styled.h4 `
  font-size: ${({ theme }) => theme.fontSizes.sizeMd1};
  font-weight: 600;
  line-height: 24px;
`;
const HeaderLink = styled(Link) `
  color: ${({ theme }) => theme.colorsV2.font.textLink};
  font-family: proxima-nova, Corbel, Arial, sans-serif;
  font-size: ${({ theme }) => theme.fontSizes.sizeSm2};
  font-weight: 600;
  line-height: 24px;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }

  &:visited {
    color: ${({ theme }) => theme.colorsV2.font.textLink};
  }
`;
export const ImagesLinksList = ({ links, listTitle, headerLinkName, headerLinkUrl, }) => {
    const closeNavigation = useContext(NaviagationContext);
    return (_jsxs(_Fragment, { children: [_jsxs(HeaderContainer, { children: [_jsx(ColumnTitle, { children: listTitle }, void 0), headerLinkUrl && headerLinkName ? (_jsx(HeaderLink, Object.assign({ href: headerLinkUrl, onClick: () => closeNavigation() }, { children: headerLinkName }), void 0)) : null] }, void 0), _jsx(List, { children: links.map(({ name, url, image }) => (_jsx(ListItem, { children: _jsx(ImageLink, { href: url, image: image, name: name, onLinkClick: () => {
                            closeNavigation();
                        } }, void 0) }, name))) }, void 0)] }, void 0));
};
//# sourceMappingURL=ImagesLinksList.js.map